module.exports = __webpack_public_path__ + "57bca7a4f1e5e1915e51b34c374733cd.pdf";